import { render, staticRenderFns } from "./invitados_no_confirmados.vue?vue&type=template&id=00ab6f4d&scoped=true"
import script from "./invitados_no_confirmados.vue?vue&type=script&lang=js"
export * from "./invitados_no_confirmados.vue?vue&type=script&lang=js"
import style0 from "./invitados_no_confirmados.vue?vue&type=style&index=0&id=00ab6f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ab6f4d",
  null
  
)

export default component.exports